import React from 'react'
import styles from './styles.module.css'

export default function NoBrandDivider(props) {
  return <div className={styles.container} />
}
